<template>
  <div
    id="burger"
    :class="{ active: !isNavClose }"
    @click="onClickOpenMenuDrawer()"
  >
    <slot>
      <button type="button" class="burger-button" title="Menu">
        <span class="burger-bar burger-bar--1"></span>
        <span class="burger-bar burger-bar--2"></span>
        <span class="burger-bar burger-bar--3"></span>
      </button>
    </slot>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("sidebar", ["isNavClose"]),
    // isBurgerActive() {
    //   return !this.isNavClose;
    // },
  },
  methods: {
    onClickOpenMenuDrawer() {
      console.log("onClickOpenMenuDrawer");
      // this.$emit("openMenuDrawerFromBurger");
      // this.$parent.$parent.$parent.$emit("openMenuDrawer");
      // this.$parent.$parent.$emit("openMenuDrawer");
      // this.$parent.$emit("openMenuDrawer");
      this.$emit("openMenuDrawer");
    },
    ...mapActions("sidebar", ["saveNavbar"]),
    // toggle() {
    //   this.saveNavbar(!this.isNavClose);
    //   const el = document.querySelector(".wizard-footer-right");
    //   if (el) {
    //     const w = document.querySelector(".dashboard").clientWidth;
    //     el.style.width = `${
    //       this.isNavClose ? w + (240 - 50) : w - (240 - 50)
    //     }px`;
    //   }
    // },
  },
};
</script>
<style>
.hidden {
  visibility: hidden;
}

#burger {
  margin-left: 0px;
  /* padding-left: 1rem; */
}

button:not(.disabled) {
  cursor: pointer;
}

button:focus {
  outline: 0;
}

.burger-button {
  position: relative;
  height: 30px;
  /* width: 30px; */
  width: 25px;
  display: block;
  z-index: 1;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  margin-left: 0px;
  margin-right: 15px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar {
  background-color: var(--color-text);
  position: absolute;
  top: 50%;
  right: 1px;
  left: 1px;
  height: 2px;
  width: auto;
  /* margin-top: 1px; */
  border-radius: var(--radius-pill);
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

/* body:has(.drawer-reports--open) #burger {
  z-index: 1001;
} */
/* 
body:has(.b-sidebar[data-open="true"]) #burger .burger-bar,
body:has(.drawer-reports--open) #burger .burger-bar,
body:has(.drawer-notifications--open) #burger .burger-bar {
  background-color: #fff;
} */

.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}

.burger-bar--2 {
  transform-origin: 100% 50%;
  transform: scaleX(1);
}

.burger-bar--3 {
  transform: translateY(6px);
}

#burger.active .burger-button {
  transform: rotate(-180deg);
}

#burger.active .burger-bar {
  background-color: white;
}

#burger.active .burger-bar--1 {
  transform: rotate(45deg);
}

#burger.active .burger-bar--2 {
  opacity: 0;
}

#burger.active .burger-bar--3 {
  transform: rotate(-45deg);
}
</style>
